import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExpertManagerEventNotificationRecord } from '@libs/shared/api';
import { SprintLogoAvatarComponent } from '@libs/shared/ui/avatar/sprint-logo-avatar.component';
import { UserAvatarComponent } from '@libs/shared/ui/avatar/user-avatar.component';

@Component({
  selector: 'app-expert-manager-created-notification',
  standalone: true,
  imports: [CommonModule, SprintLogoAvatarComponent, UserAvatarComponent],
  template: `
    <div class="flex cursor-pointer flex-row gap-4">
      <!-- Icon -->
      @if (!expertManagerEventNotification.notifier) {
        <app-sprint-logo-avatar />
      }
      <!-- Image -->
      @if (expertManagerEventNotification.notifier) {
        <app-user-avatar [user]="expertManagerEventNotification.notifier" />
      }
      <!-- Title, description & time -->
      <div class="flex w-full flex-col">
        <div class="font-semibold">
          {{ expertManagerEventNotification.receiver.nickname }}님, 가입을
          환영합니다!
        </div>
        <div class="text-secondary line-clamp-2">
          {{ expertManagerEventNotification.receiver.nickname }}님, 가입을
          환영합니다!
        </div>
        <div class="text-secondary mt-2 text-sm leading-none">
          {{
            expertManagerEventNotification.createdAt
              | date: 'yyyy-MM-dd (EEE), h:mm a'
          }}
        </div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertManagerCreatedNotificationComponent {
  @Input({ required: true })
  expertManagerEventNotification: ExpertManagerEventNotificationRecord;
}
